<template>
  <div class="scroll-container">
    <v-list-item class="no-scroll">
      <v-list-item-title class="text-h6">{{ $t("Settings") }}</v-list-item-title>
      <v-list-item-action @click="setSideDrawer(null)" style="cursor: pointer">
        <img class="vis-icon" src="/img/toolbar/Close.svg" />
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
    <v-list class="pt-0 scroll">
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("Language") }}</span>
          <v-select v-model="locale" :items="supportedLanguages"></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("InformationOverlayPosition") }}</span>
          <v-select v-model="infoOverlayPosition" :items="positionOptions" hide-details></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("NavCubePosition") }}</span>
          <v-select v-model="navCubePosition" :items="positionOptions" hide-details></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("TriadPosition") }}</span>
          <v-select v-model="triadPosition" :items="positionOptions"></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("BackgroundColor") }}</span>
          <v-select v-model="backgroundColor" :items="backgroundColorList" hide-details>
            <template v-slot:selection="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("SelectionColor") }}</span>
          <v-select v-model="selectionColor" :items="selectionColorList" hide-details>
            <template v-slot:selection="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("PMISelectionColor") }}</span>
          <v-select v-model="pmiSelectionColor" :items="pmiSelectionColorList" hide-details>
            <template v-slot:selection="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("PMIColor") }}</span>
          <v-select v-model="pmiColor" :items="pmiColorList">
            <template v-slot:selection="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar style="border: 1px solid black" height="24px" min-width="24px" width="24px">
                <span :style="{ background: data.item.value }" style="height: 100%; width: 100%"></span>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(data.item.text) }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("CameraBackground") }}</span>
          <v-select
            v-model="cameraBackgroundChoice"
            :items="cameraBackgroundOptions"
            @change="enableCameraBackground"
            hide-details
          >
          </v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <span>{{ $t("ViewType") }}</span>
          <v-select v-model="viewType" :items="viewTypes"></v-select>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="deleteAllFiles">
        <v-list-item-title>{{ $t("ClearRecentFiles") }}</v-list-item-title>
      </v-list-item>
      <v-list-item @click="restoreDefaultSettings">
        <v-list-item-title>{{ $t("RestoreDefaultSettings") }}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item
        href="https://docs.sw.siemens.com/en-US/release/296685992/JT2Go%20Mobile%207.0?releasesku=PL20201019163206581"
        target="_blank"
      >
        <v-list-item-title>{{ $t("Help") }}</v-list-item-title>
      </v-list-item>
      <v-list-item href="https://www.plm.automation.siemens.com/global/en/legal/online-terms/eula.html" target="_blank">
        <v-list-item-title>{{ $t("Legal") }}</v-list-item-title>
      </v-list-item>
      <v-list-item href="https://www.plm.automation.siemens.com/en_us/legal.shtml" target="_blank">
        <v-list-item-title>{{ $t("PrivacyPolicy") }}</v-list-item-title>
      </v-list-item>
      <v-list-item href="./ThirdParty/JT2GoMobile__7.0.1__READMEOSS_2022-08-15__17-08-04.html" target="_blank">
        <v-list-item-title>{{ $t("Acknowledgements") }}</v-list-item-title>
      </v-list-item>
      <v-list-item>
        <v-list-item-subtitle>
          JT2Go Version {{ jt2goVersion }} <br />
          &copy; 2020-2022 <br />
          Siemens Digital Industries Software
        </v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { CameraMode } from "@com.siemens.plm.web/PLMVisWeb";
import { ColorList } from "@/constants/constants.js";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: {},
  data: () => ({
    supportedLanguages: [
      { text: "English (United States)", value: "en-US" },
      { text: "Deutsch (Deutschland)", value: "de-DE" },
      { text: "français (France)", value: "fr-FR" },
      { text: "italiano (Italia)", value: "it-IT" },
      { text: "čeština (Česká republika)", value: "cs-CZ" },
      { text: "Español (España)", value: "es-ES" },
      { text: "Português (Brasil)", value: "pt-BR" },
      { text: "Magyar (Magyarország)", value: "hu-HU" },
      { text: "Polskie (Polska)", value: "pl-PL" },
      { text: "русский", value: "ru-RU" },
      { text: "日本語", value: "ja-JP" },
      { text: "한국어", value: "ko-KR" },
      { text: "中文(中华人民共和国)", value: "zh-CN" },
      { text: "中文(台灣)", value: "zh-TW" }
    ],
    positionOptions: [
      { text: "Upper Left", value: "upperLeft" },
      { text: "Upper Right", value: "upperRight" },
      { text: "Bottom Left", value: "bottomLeft" },
      { text: "Bottom Right", value: "bottomRight" },
      { text: "Off", value: "notVisible" }
    ],
    defaultBackgroundColor: { text: "Default", value: "#ffffff" },
    defaultSelectionColor: { text: "Default", value: "#ffff80" },
    defaultPmiSelectionColor: { text: "Default", value: "#0000a8" },
    defaultPmiColor: { text: "Default", value: "#000000" },
    cameraBackgroundOptions: [
      { text: "On", value: "On" },
      { text: "Off", value: "Off" }
    ],
    cameraBackgroundChoice: "Off",
    viewTypes: [
      { text: "Orthographic", value: CameraMode.ORTHOGRAPHIC },
      { text: "Perspective", value: CameraMode.PERSPECTIVE }
    ],
    jt2goVersion: process.env.VUE_APP_JT2GO_VERSION
  }),
  computed: {
    ...mapState(["cameraActive"]),
    ...mapGetters(["viewerManager"]),
    locale: {
      get: function() {
        return this.$store.state.locale;
      },
      set: function(newValue) {
        this.$store.dispatch("setLocale", newValue);
      }
    },
    infoOverlayPosition: {
      get: function() {
        return this.$store.state.infoOverlayPosition;
      },
      set: function(newValue) {
        if (this.$store.state.navCubePosition === newValue) {
          this.$store.dispatch("setNavCubePosition", this.$store.state.infoOverlayPosition);
        } else if (this.$store.state.triadPosition === newValue) {
          this.$store.dispatch("setTriadPosition", this.$store.state.infoOverlayPosition);
        }
        this.$store.dispatch("setInfoOverlayPosition", newValue);
      }
    },
    navCubePosition: {
      get: function() {
        return this.$store.state.navCubePosition;
      },
      set: function(newValue) {
        if (this.$store.state.infoOverlayPosition === newValue) {
          this.$store.dispatch("setInfoOverlyaPosition", this.$store.state.navCubePosition);
        } else if (this.$store.state.triadPosition === newValue) {
          this.$store.dispatch("setTriadPosition", this.$store.state.navCubePosition);
        }
        this.$store.dispatch("setNavCubePosition", newValue);
      }
    },
    triadPosition: {
      get: function() {
        return this.$store.state.triadPosition;
      },
      set: function(newValue) {
        if (this.$store.state.infoOverlayPosition === newValue) {
          this.$store.dispatch("setInfoOverlayPosition", this.$store.state.triadPosition);
        } else if (this.$store.state.navCubePosition === newValue) {
          this.$store.dispatch("setNavCubePosition", this.$store.state.triadPosition);
        }
        this.$store.dispatch("setTriadPosition", newValue);
      }
    },
    backgroundColor: {
      get: function() {
        return this.$store.state.backgroundColor;
      },
      set: function(newValue) {
        this.$store.dispatch("setBackgroundColor", newValue);
      }
    },
    selectionColor: {
      get: function() {
        return this.$store.state.selectionColor;
      },
      set: function(newValue) {
        this.$store.dispatch("setSelectionColor", newValue);
      }
    },
    pmiSelectionColor: {
      get: function() {
        return this.$store.state.pmiSelectionColor;
      },
      set: function(newValue) {
        this.$store.dispatch("setPmiSelectionColor", newValue);
      }
    },
    pmiColor: {
      get: function() {
        return this.$store.state.pmiColor;
      },
      set: function(newValue) {
        this.$store.dispatch("setPmiColor", newValue);
      }
    },
    viewType: {
      get: function() {
        return this.$store.state.viewType;
      },
      set: function(newValue) {
        this.$store.dispatch("setViewType", newValue);
      }
    },
    backgroundColorList: function() {
      return [this.defaultBackgroundColor].concat(ColorList);
    },
    selectionColorList: function() {
      return [this.defaultSelectionColor].concat(ColorList);
    },
    pmiSelectionColorList: function() {
      return [this.defaultPmiSelectionColor].concat(ColorList);
    },
    pmiColorList: function() {
      return [this.defaultPmiColor].concat(ColorList);
    }
  },
  mounted: function() {
    this.$root.$on("modelLoaded", this.newModelLoaded);
  },
  methods: {
    ...mapMutations(["setSideDrawer", "setCameraActive"]),
    ...mapActions(["deleteAllFiles", "restoreDefaultSettings"]),
    newModelLoaded: function() {},
    enableCameraBackground: function(value) {
      if (value === "On") {
        this.setCameraActive(true);
      } else {
        this.setCameraActive(false);
      }
    }
  }
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0px;
}
</style>
